import { useState } from "react";
import { Link } from "react-router-dom";
import { List, X, SignIn } from "@phosphor-icons/react";
import { BRAND_ASSETS } from "../../lib/brand";

const GOLD = "#c9a961";
const SCHOOL_NAV = [
  { to: "/#disciplines", label: "Disciplines" },
  { to: "/horaire", label: "Horaire" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/evenements", label: "Événements" },
  { to: "/store", label: "Boutique" },
];
const PRODUCT_NAV = [
  { to: "/dojova#flux", label: "Fonctionnalités" },
  { to: "/dojova#arena", label: "Arena" },
  { to: "/dojova#tarifs", label: "Tarifs" },
  { to: "/franchise", label: "Méthode Kaizen" },
  { to: "/dojova#demo", label: "Démo" },
];

const NavLink = ({ to, label, onClick }) => {
  const cls = "hover:text-[#c9a961] transition-colors";
  return to.includes("#") ? <a href={to} onClick={onClick} className={cls}>{label}</a> : <Link to={to} onClick={onClick} className={cls}>{label}</Link>;
};

// En-tête public harmonisé : école (défaut) ou produit DOJOVA. Sticky (pas fixed) → aucun chevauchement de contenu.
export function PublicHeader({ product = false }) {
  const [open, setOpen] = useState(false);
  const nav = product ? PRODUCT_NAV : SCHOOL_NAV;
  return (
    <header data-testid="public-header" className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10 text-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between gap-3">
        <Link to={product ? "/dojova" : "/"} className="flex items-center gap-3 shrink-0" data-testid="public-logo-link">
          {product
            ? <><img src="/brand/dojova-icon-192.png" alt="DOJOVA" className="h-9 w-9 rounded-lg" /><span className="flex flex-col leading-none brand-sans"><span className="font-bold tracking-[0.26em] uppercase text-sm">Dojova</span><span className="text-[9px] uppercase tracking-[0.2em] text-white/55 mt-[3px]">— Kaizen System</span></span></>
            : <img src={BRAND_ASSETS.MASTER_TEXT} alt="Institut Impact Élite Martial" className="h-11 sm:h-14 w-auto object-contain drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]" />}
        </Link>
        <nav className="hidden lg:flex items-center gap-6 text-sm whitespace-nowrap" data-testid="public-nav">
          {nav.map((n) => <NavLink key={n.to} {...n} />)}
        </nav>
        <div className="flex items-center gap-2 shrink-0">
          <Link to={product ? "/auth" : "/membres"} data-testid="public-nav-connexion"
            className="hidden sm:inline-flex items-center gap-1.5 border border-white/25 rounded-full px-3.5 py-1.5 text-sm hover:border-[#c9a961] hover:text-[#c9a961] transition-colors">
            <SignIn size={14} /> Connexion
          </Link>
          {product
            ? <a href="/dojova#demo" data-testid="public-cta" className="inline-flex bg-rose-600 hover:bg-rose-500 text-white px-4 sm:px-5 py-2 sm:py-2.5 text-[12px] sm:text-sm font-bold uppercase tracking-wide rounded transition-colors">Demander une démo</a>
            : <Link to="/cours-essai" data-testid="public-cta" className="inline-flex bg-[#D90429] text-white px-4 sm:px-5 py-2 sm:py-2.5 text-[12px] sm:text-sm font-bold uppercase tracking-wide rounded hover:bg-white hover:text-[#D90429] transition-colors">Cours d'essai</Link>}
          <button onClick={() => setOpen(true)} aria-label="Ouvrir le menu" data-testid="public-menu-toggle"
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg border border-white/20 hover:border-[#c9a961] hover:text-[#c9a961] transition-colors"><List size={20} /></button>
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-[70] lg:hidden" data-testid="public-menu-panel">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-0 h-full w-[86%] max-w-sm bg-[#0d0d0d] border-l border-white/10 flex flex-col">
            <div className="flex items-center justify-between px-5 h-16 border-b border-white/10">
              <span className="font-semibold uppercase tracking-widest text-sm" style={{ color: GOLD }}>Menu</span>
              <button onClick={() => setOpen(false)} aria-label="Fermer" className="w-10 h-10 inline-flex items-center justify-center rounded-lg border border-white/20"><X size={20} /></button>
            </div>
            <nav className="flex flex-col p-3 text-base">
              {nav.map((n) => <div key={n.to} className="px-3 py-3.5 border-b border-white/5"><NavLink {...n} onClick={() => setOpen(false)} /></div>)}
              <Link to={product ? "/auth" : "/membres"} onClick={() => setOpen(false)} className="px-3 py-3.5 text-[#c9a961]">Connexion</Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}

export function PublicFooter({ product = false }) {
  return (
    <footer data-testid="public-footer" className="bg-[#0a0a0a] border-t border-white/10 text-zinc-400">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          {product
            ? <img src="/brand/dojova-logo-dark.png" alt="DOJOVA — Kaizen System" className="h-14 w-auto rounded-lg" />
            : <img src={BRAND_ASSETS.MASTER_TEXT} alt="Institut Impact Élite Martial" className="h-14 w-auto object-contain" />}
          <p className="text-sm mt-4 max-w-sm leading-relaxed">
            {product ? "Le système du dojo : gestion, paiements, communications, compétitions et livestream — par Kaizen System." : "Muay Thaï, kickboxing, jiu-jitsu brésilien, Can-Ryu et Petits Samouraïs à Val-d'Or. Une école, une méthode : Kaizen System."}
          </p>
        </div>
        <div className="text-sm">
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">Navigation</p>
          <ul className="space-y-2.5">
            {(product ? PRODUCT_NAV : SCHOOL_NAV).map((n) => <li key={n.to}><NavLink {...n} /></li>)}
            <li><Link to={product ? "/" : "/dojova"} className="hover:text-[#c9a961] transition-colors">{product ? "Institut Impact Élite Martial" : "DOJOVA — le logiciel"}</Link></li>
            {product && <li><Link to="/dojova/marque" className="hover:text-[#c9a961] transition-colors" data-testid="footer-brand-link">Charte & logos</Link></li>}
          </ul>
        </div>
        <div className="text-sm">
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">Légal & contact</p>
          <ul className="space-y-2.5">
            <li><Link to="/privacy-policy" className="hover:text-[#c9a961] transition-colors">Confidentialité</Link></li>
            <li><Link to="/terms-of-service" className="hover:text-[#c9a961] transition-colors">Conditions d'utilisation</Link></li>
            <li><Link to="/data-deletion" className="hover:text-[#c9a961] transition-colors">Suppression des données</Link></li>
            <li><a href="mailto:info@kaizenfranchise.com" className="hover:text-[#c9a961] transition-colors">info@kaizenfranchise.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-[10px] uppercase tracking-[0.25em] text-zinc-600">
        © 2026 Institut Impact Élite Martial · <span className="text-amber-500/90 font-bold">DOJOVA</span> — Kaizen System
      </div>
    </footer>
  );
}

// Enveloppe de route : en-tête + page + pied de page harmonisés, sans toucher au code de la page.
export function PublicPage({ children, footer = true }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col" data-testid="public-page">
      <PublicHeader />
      <div className="flex-1">{children}</div>
      {footer && <PublicFooter />}
    </div>
  );
}
